import { Subject } from 'rxjs';
import { VmpFieldType, VmpSelectionType } from '../enums';

// noinspection JSUnusedGlobalSymbols
export class ViewModelProperty<T = any | undefined> {
  fieldName = '';
  caption = '';
  infoText = '';
  fieldType: VmpFieldType = VmpFieldType.Unspecified;
  fieldLen = 0;
  listFunction = '';
  valueList: string[] = [];
  selectionType: VmpSelectionType = VmpSelectionType.None;
  initialValue: any = undefined;
  displayValue: any = undefined;
  required = false;
  readOnly = false;
  order = 0;
  groupName = '';
  subGroupName = '';
  loading = false;
  style = '';

  private _value?: T = undefined;
  valueChange: Subject<any> = new Subject<any>();

  get value(): T | undefined {
    return this._value;
  }

  set value(newValue: T | undefined) {
    if (this._value == newValue) {
      return;
    }
    this._value = newValue;
    this.valueChange.next(newValue);
  }
}
